import type { ReactNode } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

export interface TabTableProps {
  /** 表の名前（スクリーンリーダー向け）。 */
  ariaLabel: string;
  /** 「順序」列を出すか（グループ未指定のタブは順を持たないため出さない）。 */
  showOrder: boolean;
  /** `TabRow` の行。 */
  children: ReactNode;
}

/**
 * タブの一覧表。列をそろえて行をまたいだ状態の比較をしやすくする。色と余白は shadcn のトークンに合わせる
 * （MUI 既定の色・フォントを持ち込まない）。
 */
export function TabTable({ ariaLabel, showOrder, children }: TabTableProps) {
  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table
        size="small"
        aria-label={ariaLabel}
        sx={{
          minWidth: 1080,
          '& .MuiTableCell-root': {
            fontFamily: 'inherit',
            color: 'inherit',
            borderColor: 'hsl(var(--border))',
          },
          '& .MuiTableCell-head': {
            backgroundColor: 'hsl(var(--background))',
            color: 'hsl(var(--muted-foreground))',
            fontSize: 12,
            fontWeight: 500,
            lineHeight: 1.5,
            py: 1,
            borderTop: '1px solid hsl(var(--border))',
            whiteSpace: 'nowrap',
          },
          '& .MuiTableCell-body': { py: 1.25, verticalAlign: 'middle' },
          '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-body': {
            borderBottom: 0,
          },
          '& .MuiTableBody-root .MuiTableRow-root:hover': {
            backgroundColor: 'hsl(var(--background))',
          },
        }}
      >
        <TableHead>
          <TableRow>
            {showOrder && (
              <TableCell align="center" sx={{ width: 64 }}>
                順序
              </TableCell>
            )}
            <TableCell>タブ</TableCell>
            <TableCell sx={{ width: 200 }}>公開状態</TableCell>
            <TableCell sx={{ width: 196 }}>直近のデータ更新</TableCell>
            <TableCell sx={{ width: 160 }}>定期更新</TableCell>
            <TableCell align="right">操作</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{children}</TableBody>
      </Table>
    </TableContainer>
  );
}
